import React from 'react';
import LegalLayout, { LegalSection } from '../../components/LegalLayout';

export default function CookiesEN() {
  return (
    <LegalLayout title="Cookie policy" lastUpdated="January 1, 2025">
      <div style={{ background: 'rgba(255,193,7,0.08)', border: '1px solid rgba(255,193,7,0.3)', borderRadius: '8px', padding: '12px 16px', marginBottom: '24px' }}>
        <p style={{ color: '#ffc107', fontSize: '13px', margin: 0 }}>
          <strong>Information only:</strong> This is a summary translation for information purposes only.
          The French version is the sole legally binding version. In case of discrepancy, the French version shall prevail.
        </p>
      </div>
      <LegalSection title="1. What are cookies?">
        <p>Cookies are small text files stored on your device when you visit a website. They allow the site to remember your preferences and provide a better user experience.</p>
      </LegalSection>
      <LegalSection title="2. Cookies used by Kurso">
        <p><strong>Necessary cookies (always active):</strong></p>
        <ul>
          <li><code>kurso_access_token</code> — authentication token (session)</li>
          <li><code>kurso_refresh_token</code> — session renewal (30 days)</li>
          <li><code>kurso_cookie_consent</code> — your cookie preferences (localStorage)</li>
        </ul>
        <p className="mt-3"><strong>Analytics cookies (Mixpanel — requires consent):</strong></p>
        <ul>
          <li>Collect anonymous usage data: pages visited, features used, session duration</li>
          <li>Used to improve the platform and understand user needs</li>
          <li>Data retained for 13 months</li>
        </ul>
        <p className="mt-3"><strong>Marketing cookies (requires consent):</strong></p>
        <ul>
          <li>Allow display of relevant advertising</li>
          <li>Measure advertising campaign effectiveness</li>
        </ul>
      </LegalSection>
      <LegalSection title="3. How to manage your preferences">
        <p>You can change your cookie preferences at any time by clicking <strong>"🍪 Manage cookies"</strong> in the footer of any page.</p>
        <p>You can also manage cookies through your browser settings:</p>
        <ul>
          <li>Chrome: Settings → Privacy and security → Cookies</li>
          <li>Firefox: Settings → Privacy and security → Cookies</li>
          <li>Safari: Preferences → Privacy → Manage website data</li>
        </ul>
        <p>Note: disabling necessary cookies will prevent you from logging in to Kurso.</p>
      </LegalSection>
      <LegalSection title="4. Contact">
        <p>For any question about our cookie policy, contact us at <a href="mailto:rgpd@mykurso.fr" className="text-[#ff6b6b]">rgpd@mykurso.fr</a>.</p>
      </LegalSection>
    </LegalLayout>
  );
}
